import { render, staticRenderFns } from "./AddRevisionPage.vue?vue&type=template&id=17fafbdf"
import script from "./AddRevisionPage.vue?vue&type=script&lang=js"
export * from "./AddRevisionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports